import { useRef, useState, useLayoutEffect, useEffect, useMemo } from 'react';
export var MEDIUM_CLASS = 'medium';
export var LARGE_CLASS = 'large';
export var EXTRA_LARGE_CLASS = 'x-large';
export var MEDIUM_SIZE = 740;
export var LARGE_SIZE = 972;
export var EXTRA_LARGE_SIZE = 1200;
export var useElementWidth = function () {
    var ref = useRef(null);
    var _a = useState(0), width = _a[0], setWidth = _a[1];
    useLayoutEffect(function () {
        var _a, _b;
        setWidth((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : 0);
    }, []);
    useEffect(function () {
        var handler = function () { var _a, _b; return setWidth((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : 0); };
        window.addEventListener('resize', handler);
        return function () { return window.removeEventListener('resize', handler); };
    }, []);
    return { ref: ref, width: width };
};
export var useClassNames = function (width) {
    return useMemo(function () {
        var result = [];
        if (width >= MEDIUM_SIZE) {
            result.push(MEDIUM_CLASS);
        }
        if (width >= LARGE_SIZE) {
            result.push(LARGE_CLASS);
        }
        if (width >= EXTRA_LARGE_SIZE) {
            result.push(EXTRA_LARGE_CLASS);
        }
        return result.join(' ');
    }, [width]);
};
